jQuery(document).ready(function () {
  var $document = jQuery(document);

  $('.header-top-price').off('click');

  $document.on('click', '.copper-price-toggle', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $this = jQuery(this);
    var $toggle = $this.find('.header-top-price');
    var $body = jQuery('#wrapper > header > .header-top-price-dropdown');
    var $navigation = jQuery('#main-navigation');

    if (!$toggle.hasClass('js-open')) {
      // Close Mega Navi
      if($('#megamenu').hasClass('active')) {
        $('.megamenu-close').trigger('click');
        setTimeout(function() {
          $navigation.addClass('navigation-white');
        },350);
      } else {
        $navigation.addClass('navigation-white');
      }


      window.setTimeout(function () {
        $body.addClass('open');
        $toggle.addClass('js-open');
        window.setTimeout(function(){
          $('body').addClass('disallow-scroll');
        },1000);
      }, 100);
    } else {
      $body.removeClass('open');
      $toggle.removeClass('js-open');
      $('body').removeClass('disallow-scroll');

      window.setTimeout(function () {
        if ($navigation.data('navigation-style') !== 'white') {
          $navigation.removeClass('navigation-white');
        }
      }, 900);
    }
  });

  $document.on('click', '.copperapi-close', function (e) {
    e.preventDefault();
    e.stopPropagation();

    $('.copper-price-toggle').trigger('click');
  });
});
